export const userAvatarFallback = (username?: string) => {
  return username?.slice(0, 2) ?? 'pp';
};

export const randomColor = () => {
  const colors = [
    'bg-red-300',
    'bg-amber-300',
    'bg-lime-300',
    'bg-green-300',
    'bg-emerald-300',
    'bg-teal-300',
    'bg-indigo-300',
    'bg-purple-300',
  ];
  const randomColor = Math.floor(Math.random() * colors.length);
  return colors[randomColor];
};
